import { reduceCollectionHandler } from 'utils/model';
import { FETCH_DEVICES } from './actions';

const initialState = { data: [] };

export default function devices(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case FETCH_DEVICES:
      return reduceCollectionHandler(state, action);

    default:
      return state;
  }
}
